import type { NextPage } from 'next';
import MadIdComponent from '@components/projects/mad-id/mad-id';
import ProjectLayout from '@layouts/project-layout/project-layout';
import { ProjectProps } from '@models/project.interface';

const MadID: NextPage<ProjectProps> = (project) => {
  return (
    <ProjectLayout project={project}>
      <MadIdComponent breadcrumbsText={project.project.breadcrumbsText} />
    </ProjectLayout>
  );
};

export default MadID;
export { getServerSideProps } from '@layouts/project-layout/project-layout';
